import mainApi from "./mainApi";
import { getEnvVariables } from "helpers/getEnvVariables";
import {
  getDefaultFilename,
  getPdfAttachmentFromHtml,
  getPdfAttachmentWithData,
} from "./pdfGeneratorApi";

export const sendEmailWithData = async (postData) => {
  const { data } = await mainApi.post("/email/pdf", postData);
  return data;
};
const { VUMI_LOGIN_URL } = getEnvVariables()


export const sendEmailWithPdfUsingAppNumber = async (appNumber, aplication = 0) => {
  const { data } = await mainApi.get(`/cotizador/${appNumber}`);

  const postData = data['data']

  const { data: html } = await mainApi.get(`/application_html/${appNumber}`, {
    responseType: "plain/text",
  });

  const attachment = await getPdfAttachmentFromHtml(html, getDefaultFilename(postData));

  const { data: email } = await sendEmailWithData({
    to: postData["email"],
    attachments: [attachment],
    name: `${postData["name"]} ${postData["surname"]}`,
    url: VUMI_LOGIN_URL,
    locale: postData["locale"],
    applicationId: aplication,
  });

  return email;
};


export const sendEmailWithPdf = async (postData, user) => {
  const attachment = await getPdfAttachmentWithData(postData);

  const { data: email } = await sendEmailWithData({
    to: postData["to"],
    attachments: [attachment],
    name: `${postData["name"]} ${postData["surname"]}`,
    url: postData["url"] ?? VUMI_LOGIN_URL,
    locale: postData["locale"],
    applicationId: postData["applicationId"],
  });

  return email;
};
